
export enum StatusType {
  SUCCESS,
  ERROR,
  ERROR_INPUT
}
